import { ContentType } from "@/api/scode/scode_params";
import loadingPng from "@/base64";
import PosterSwipePro from "@/components/poster-swiper/pro";
import { platform } from "@/utils/platform";
import { getRatio, pxtorem } from "@/utils/pxtorem";
import AKJS from "@akc/akjs";
import { useThrottleFn } from "ahooks";
import { Image, } from "antd-mobile";
import React, { ReactNode, useCallback, useEffect, useRef, useState } from "react";
import BackView from "./components/BackView";
import customStyles from "./components/CustomTopBack.module.less";
import EmptyView from "./components/EmptyView";
import FloatingTopBar from "./components/FloatingTopBar";
import NavHeader4App from "./components/NavHeader4App";
import RankBottomListView from "./components/RankBottomListView";
import SeeAllView from "./components/SeeAllView";
import TopListView from "./components/TopLIstView";
import { useAppStatusBarHeight } from "./hooks/useAppStatusBarHeight";
import { useRankScale } from "./hooks/useRankScale";
import { useRankShare } from "./hooks/useRankShare";
import { useRankSystemShare } from "./hooks/useRankSystemShare";
import styles from "./index.module.less";

// 页面容器组件
const PageContainer: React.FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className={`pageContainer ${platform.isH5 ? customStyles.container_with_top_back : ""} ${platform.isiOS ? customStyles.noBottomBounce : ""}`}>
    {children}
  </div>
);



// 全部榜单按钮组件
const AllRankButton: React.FC<{
  onClick: () => void;
  statusBarHeight?: number;
}> = ({ onClick, statusBarHeight = 50 }) => (
  <div className={styles.rankallview} onClick={onClick} style={{ top: platform.isApp ? (statusBarHeight + 15) * getRatio() : 9 }}>
    <div className={styles.allRank}>全部榜单</div>
    <img
      src="https://akim-oss.aikucun.com/1db67b528a43de2bebca495a6b1a0ef4931e3316_1741166862255_15.png"
      alt="Success"
      className={styles.moreIcon}
    />
  </div>
);


// 底部分享、转发按钮组件
const BottomButton: React.FC<{
  onClick: () => void;
  currentRole: string;
}> = ({ onClick, currentRole }) => (
  <div className={styles.bottomBtn} onClick={onClick}>
    {currentRole === "C" ? (
      <div className={styles.bottomBtnText}>分享榜单</div>
    ) : (
      <div className={styles.bottomBtnTextMoney}>转发赚钱</div>
    )}
  </div>
);

// 更多榜单标题组件
const MoreRankTitle: React.FC = () => (
  <div className={styles.moreRank}>
    <img
      src="https://akim-oss.aikucun.com/5ab5746f52602eaf15d5d6561d5d882967bc7c83_1740645244223_99.png"
      alt="Success"
      className={styles.moreRankImg}
    />
    <div className={styles.moreRankText}>更多榜单</div>
    <img
      src="https://akim-oss.aikucun.com/5ab5746f52602eaf15d5d6561d5d882967bc7c83_1740645244223_99.png"
      alt="Success"
      className={styles.moreRankImg}
    />
  </div>
);

// 查看全部榜单按钮组件
const SeeAllRankButton: React.FC<{
  onClick: () => void;
}> = ({ onClick }) => (
  <div className={styles.toSeeAllView}>
    <div className={styles.toSeeAll} onClick={onClick}>
      查看全部榜单
    </div>
  </div>
);

// 榜单头部组件
const RankHeader: React.FC<{
  rankName?: string;
  isHasRankData?: boolean;
}> = ({ rankName, isHasRankData = true }) => (
  <div className={styles.mainHeader}>
    <img
      src={isHasRankData
        ? "https://akim-oss.aikucun.com/b49d405ebebad83db17f09a4931ab5548650b563_1740641684863_39.png"
        : "https://akim-oss.aikucun.com/1e629a0b6d39e51e59273cfe7846e48bf7236498_1742200887633_61.png"
      }
      alt="Success"
      className={styles.img}
    />
    <div className={styles.mainTitle}>
      {rankName}
    </div>
    <img
      src={isHasRankData
        ? "https://akim-oss.aikucun.com/cd1ea46643110c67fcc1079bee1d5ea724624fba_1740641689386_28.png"
        : "https://akim-oss.aikucun.com/5c7f0bf02ad95b8377d7096775c4d17b228ec732_1742200882836_6.png"
      }
      alt="Success"
      className={styles.img}
    />
  </div>
);



/**
 * 榜单规模化
 */
const RankScale: React.FC = () => {
  const [isTabSticky, setIsTabSticky] = useState(false);
  // 创建两个容器的引用
  const detailListRef = useRef<HTMLDivElement>(null);
  const expiredListRef = useRef<HTMLDivElement>(null);
  // 创建滚动容器的引用
  const containerRef = useRef<HTMLDivElement>(null);

  const control = useRankScale();
  const { getRankDataList, hasMore, rankDetail, detailInitEndRef, rankProducts,prdInitEndRef, goToRankAll, goToProductDetail, goToRankScale, 
    rankDataList, brotherRankInitEndRef, loading, track, search, pageName, commonContext } = control;
  // 使用榜单分享Hook
  const { swiperControl, productControl, handleShareProduct } = useRankShare({
    rankShare: {
      contentType: ContentType.categoryRank,
      contentId: rankDetail?.rankNo || "",
      marketName: "榜单详情",
    },
  });
  // 系统分享配置;
  useRankSystemShare({
    rankShare: {
      contentType: ContentType.categoryRank,
      contentId: rankDetail?.rankNo || "",
      shareType: "HOT_LIST_CATEGORY",
      posterCode: "CategoryHotListPoster",
      pageName: "榜单详情",
      title:""
    },
  });

  // 是否有兄弟榜单
  const hasBrotherRankList = rankDataList && rankDataList.length > 0;

  // 状态栏高度
  const statusBarHeight = useAppStatusBarHeight();

  // 监听容器的滚动位置,判断何时开始吸顶
  const checkContainerPosition = useCallback(() => {
    if (!detailInitEndRef.current) {
      return;
    }
    // 获取当前应该监听的容器
    const currentRef = rankDetail ? detailListRef : expiredListRef;
    if (currentRef.current) {
      const rect = currentRef.current.getBoundingClientRect();
      // 计算适配不同屏幕的阈值（44px是在375*812标准屏下的尺寸）
      const adaptiveThreshold = (platform.isApp? (statusBarHeight * getRatio()):0)+ 60;
      // 当容器顶部距离视口顶部小于等于阈值时，设置isTabSticky为true
      // console.log("rect.top", rect.top, "adaptiveThreshold", adaptiveThreshold);
      const shouldSticky = rect.top <= adaptiveThreshold;
      setIsTabSticky(shouldSticky);
    }
  }, [detailInitEndRef,rankDetail, statusBarHeight]);

  // 使用 ahooks 的 useThrottleFn 进行节流控制
  const { run: throttledCheckPosition } = useThrottleFn(
    () => {
      checkContainerPosition();
    },
    { wait: 100 } // 设置100ms的节流时间
  );

  // 设置滚动监听
  useEffect(() => {
    let cleanupFunction: (() => void) | null = null;

    // 延迟执行，确保DOM已渲染
    const timer = setTimeout(() => {
      // 获取真正的滚动容器元素
      const containerElement = containerRef.current;
      if (!containerElement) {
        console.error("滚动容器containerElement不存在，可能尚未加载完成");
        return;
      }

      // 监听容器的滚动位置,判断何时开始吸顶，初始执行一次
      checkContainerPosition();

      // 添加滚动事件监听到renderMainContent容器上，使用节流函数
      const handleScroll = () => {
        throttledCheckPosition();
      };

      containerElement.addEventListener("scroll", handleScroll, { passive: true });

      // 设置清理函数
      cleanupFunction = () => {
        containerElement.removeEventListener("scroll", handleScroll);
      };
    }, 300);

    // 清理函数
    return () => {
      clearTimeout(timer);
      if (cleanupFunction) {
        cleanupFunction();
      }
    };
  }, []);

  // 点击底部分享赚钱
  const clickShareMontyBtn = () => {
    console.log("clickShareMontyBtn",rankDetail);
    swiperControl.open({
      bizInfo: {
        contentId: rankDetail?.rankNo || "",
      },
      envContext: {
        sourceSceneId: rankDetail?.rankNo || "",
      },
      contentContext: {
        contentId: rankDetail?.rankNo || "",
      },
    });

    if (track.track) {
      track.track("btn_click", {
        page_name: "榜单详情",
        page_code: rankDetail?.rankNo || "",
        previous_page_name: search.get("page_name"),
        btn_name: commonContext.currentRole === "C" ? "分享榜单" : "转发赚钱",
        btn_text: commonContext.currentRole === "C" ? "分享榜单" : "转发赚钱"
      });
    }
  };

  useEffect(() => {
    document.title = "热卖榜单";
    if (track.track) {
      track.track("$pageview", {
        page_name: "榜单详情",
        content_id: rankDetail?.rankNo,
        previous_page_name: search.get("page_name"),
      });
    }
    if (platform.isApp) {
      AKJS.ready().then(() => {
        AKJS.action
          .dispatch("event.navigationBar.hide", {
            hide: true,
          })
          .catch(error => {
            console.error("设置顶部导航栏失败:", error);
          });
      });
    }
  }, []);

  const showAllEmptyView = () => {
    return <div className={styles.tsss}>
      {
        !platform.isApp && <BackView />
      }
      <FloatingTopBar />
      <div style={{ paddingTop: "100px" }}></div>
      <EmptyView text={"当前榜单已过期失效～"} />

      <SeeAllView goToRankAll={goToRankAll} />
    </div>;
  };

  // 有榜单详情的情况下，渲染榜单内容
  const renderRankDetailContent = () => (
    <div className={styles.renderRankDetailContent}>
      {/* 背景图中间的内容 */}
      {/* 榜单头部内容组件（两侧枝条+中间榜单名称） */}
      <RankHeader rankName={rankDetail?.rankName} isHasRankData={!!hasBrotherRankList} />
      <div className={styles.tips}>数据实时更新，请以榜单页面排名为准</div>

      {/* 榜单内容 */}
      <div className={styles.stickyContainer + " detailListRef"} ref={detailListRef}>
        {prdInitEndRef.current && <TopListView
          rankDetail={{
            ...rankDetail,
            productList: rankProducts,
          }}
          handleShareProduct={handleShareProduct}
          pageName={pageName}
        />}

        {hasBrotherRankList ? (
          <>
            {rankDataList && rankDataList.length > 0 && <MoreRankTitle />}
            <RankBottomListView
              data={rankDataList}
              loadMore={getRankDataList}
              tabName={"更多榜单"}
              hasMore={hasMore}
              toRankDetailAction={(rankno, tsindex) => goToRankScale(rankno, tsindex)}
              type={0}
            />
            {!hasMore && <SeeAllRankButton onClick={goToRankAll} />}
          </>
        ) : (
          <div className={styles.hastopnobottom}>
            <div className={styles.bottomTextshow}>--已经到底了--</div>
            <div className={styles.toSeeAllViewNoBottom}>
              <div className={styles.toSeeAllNoBottom} onClick={goToRankAll}>
                查看全部榜单
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  // 渲染当前榜单过期内容（当前过期榜单+兄弟榜单）
  const renderExpiredRankContent = () => {
    return (
      <div className={styles.renderRankDetailContent}>
        <div className={styles.stickyContainer + " expiredListRef"} ref={expiredListRef}>
          <div style={{ paddingTop: "100px" }}></div>
          {detailInitEndRef.current && <EmptyView
              style={{
                height: "auto",
              }}
              text={"当前榜单已过期失效～"} />}

          {rankDataList && rankDataList.length > 0 && <MoreRankTitle />}

          <RankBottomListView
            data={rankDataList}
            loadMore={getRankDataList}
            tabName={"更多榜单"}
            hasMore={hasMore}
            toRankDetailAction={(rankno, tsindex) => goToRankScale(rankno, tsindex)}
            type={0}
          />

          {!hasMore && <SeeAllRankButton onClick={goToRankAll} />}
        </div>
      </div>
    );
  };

  // 渲染主内容(商品列表+兄弟榜单)
  const renderMainContent = () => {

    // 没有榜单数据且没有排行榜数据
    if (detailInitEndRef.current && !rankDetail && brotherRankInitEndRef.current && !hasBrotherRankList) {
      return showAllEmptyView();
    }

    return (
      <>
        {/* 全部榜单按钮：从榜单列表过来的不展示 */}
        {(rankDetail ? !search.get("fromAll") : true) && (
          <AllRankButton onClick={goToRankAll} statusBarHeight={statusBarHeight} />
        )}

        {/* 背景图片 */}
        <img src={rankDetail?.rankImg || "https://akim-oss.aikucun.com/b78abf914809eb42ea1e1dcbed7ac52ad65d4bc0_1742379635755_97.png"}  alt="Success" className={styles.bgImgapp} />


        {/* 根据是否有榜单详情渲染不同内容 */}
        {rankDetail ? renderRankDetailContent() : renderExpiredRankContent()}

        {/* 底部按钮 */}
        {(rankDetail || hasBrotherRankList) && (
          <BottomButton
            onClick={clickShareMontyBtn}
            currentRole={commonContext.currentRole}
          />
        )}
      </>
    );
  };

  return (
    <PageContainer>
      {/* 榜单分享 */}
      <PosterSwipePro {...swiperControl.props} />
      {/* 商品分享 */}
      <PosterSwipePro {...productControl.props} />

      {/* H5的导航头部，及吸顶背景 */}
      {platform.isH5 && <FloatingTopBar isSticky={isTabSticky} />}

      {/* app的返回组件及吸顶背景 */}
      {platform.isApp && <NavHeader4App
        rankName={rankDetail?.rankName || "热卖榜单"}
        statusBarHeight={statusBarHeight}
        isTabSticky={isTabSticky} />}


      <div className={styles.renderMainContent} ref={containerRef}>
        {renderMainContent()}

        {loading && (
          <div className={styles.loadingIcon}>
            <Image src={loadingPng} width={pxtorem(30)}></Image>
          </div>
        )}
      </div>
    </PageContainer>
  );
};

export default RankScale;
